module.exports = __webpack_public_path__ + "assets/images/games/bg_overlay.2e85348.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/games/carrot-game/bg_overlay.png
// module id = 1631
// module chunks = 1